import { paymentMethodConstants } from "../_constants";
import { alertActions } from "./alert.actions";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
export const paymentMethodActions = {
  getPaymentMethodList,
  createPaymentMethod,
  updatePaymentMethod,
  deletePaymentMethod,
  UpdatePaymentMethodStatus,
  getCountryCodeList,paymentIntentListForAdmin,createFeedBackAdmin,getFeedbackListIntentWise,updateOrderStatusByAdminOrMerchant
};

//get
function getPaymentMethodList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentMethod/getPaymentMethodList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: paymentMethodConstants.GET_PAYMENT_METHOD_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: paymentMethodConstants.GET_PAYMENT_METHOD_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: paymentMethodConstants.GET_PAYMENT_METHOD_LIST_FAILURE,
      error,
    };
  }
}

//create
function createPaymentMethod(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentMethod/createPaymentMethod",
  };
  console.log("data", data)
  return APIcallFunction(credentials)
}

//update
function updatePaymentMethod(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentMethod/updatePaymentMethod",
  };
  return APIcallFunction(credentials)
}

//delete
function deletePaymentMethod(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentMethod/deletePaymentMethod",
  };
  return APIcallFunction(credentials)
}


function UpdatePaymentMethodStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentMethod/updatePaymentMethodStatus ",
  };
  return APIcallFunction(credentials)
}

//get CountryCodeList
function getCountryCodeList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/getAllCountryCodeListApi",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: paymentMethodConstants.GET_COUNTRY_CODE_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: paymentMethodConstants.GET_COUNTRY_CODE_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: paymentMethodConstants.GET_COUNTRY_CODE_LIST_FAILURE,
      error,
    };
  }
}

//// BUY PKRD PAYEMNT HISTORY LIST
function paymentIntentListForAdmin(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/paymentIntent/paymentIntentListForAdmin",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_FAILURE,
      error,
    };
  }
}


function createFeedBackAdmin(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/feedback/createFeedBackAdmin'
  };
  return APIcallFunction(credentials);

}


function getFeedbackListIntentWise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/feedback/getFeedbackListIntentWise'
  };
  return APIcallFunction(credentials);

}



function updateOrderStatusByAdminOrMerchant(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/paymentIntent/updateOrderStatusByAdminOrMerchant'
  };
  return APIcallFunction(credentials);

}